import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { responseSetService } from "../services/responseSetService";

function ResponseSetPage() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [responseSet, setResponseSet] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    responseSetService.get(token).then((data) => {
      setResponseSet(data);
      setLoading(false);
    }).catch(() => {
      setError("Unable to load your assessment results. Please try again.");
      setLoading(false);
    });
  }, [token]);

  function handleViewResources() {
    if (!responseSet) return;
    const params = new URLSearchParams();
    params.set("response_id", responseSet.token || token);
    if (responseSet.location) params.set("location", responseSet.location);
    if (responseSet.search_params?.taxonomy_code) {
      params.set("taxonomy_code", responseSet.search_params.taxonomy_code.join(","));
    }
    if (responseSet.search_params?.age_range) {
      params.set("age_range", responseSet.search_params.age_range);
    }
    if (responseSet.search_params?.referral) {
      params.set("referral", responseSet.search_params.referral);
    }
    params.set("page", "1");
    params.set("survey_name", responseSet.name || "");
    navigate(`/search?${params.toString()}`);
  }

  function handleEdit() {
    if (responseSet?.survey_id) {
      navigate(`/assessments/${responseSet.survey_id}`);
    }
  }

  function handlePdfDownload() {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = "/response_sets/export.pdf";
    form.target = "_blank";

    const tokenInput = document.createElement("input");
    tokenInput.type = "hidden";
    tokenInput.name = "token";
    tokenInput.value = token;
    form.appendChild(tokenInput);

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    if (csrfToken) {
      const csrfInput = document.createElement("input");
      csrfInput.type = "hidden";
      csrfInput.name = "authenticity_token";
      csrfInput.value = csrfToken;
      form.appendChild(csrfInput);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  if (error) {
    return (
      <div className="survey-container row">
        <div className="survey-content">
          <p className="text-danger">{error}</p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="survey-container row">
        <div className="survey-content">
          <div className="loading-content">
            <div className="preloader">
              <div className="dot1" />
              <div className="dot2" />
            </div>
            <p className="direct">Loading</p>
          </div>
        </div>
      </div>
    );
  }

  const taxonomyNames = responseSet?.responses
    ?.map((r) => r.answer?.search_params?.taxonomy_name || r.question?.category)
    .filter(Boolean)
    .filter((v, i, arr) => arr.indexOf(v) === i) || [];

  return (
    <div className="survey-container row">
      <div className="survey-content">
        <div className="summary">
          <div className="top-content">
            <p>Thank you for completing the assessment!</p>
            <h2>Based on your responses, we recommend the following resources:</h2>
            {taxonomyNames.length > 0 && (
              <ul>
                {taxonomyNames.map((name, i) => (
                  <li key={i}>{name}</li>
                ))}
              </ul>
            )}
            <button
              className="btn btn-primary btn-lg nav-to-search"
              onClick={handleViewResources}
            >
              View Resources Near You
            </button>
          </div>

          <button
            className="btn btn-default pdf-download"
            onClick={handlePdfDownload}
          >
            Download your responses (PDF)
          </button>

          <a className="edit-link" onClick={handleEdit} role="button" tabIndex={0}>
            Want to change your answers? Change them
          </a>
        </div>
      </div>
    </div>
  );
}

export default ResponseSetPage;
